import { useEffect } from 'react';
import { Spinner, Alert } from 'react-bootstrap';
import { FaCheckCircle, FaClock } from 'react-icons/fa';
import { useGetInvoiceStatusQuery } from '../../slices/orderApiSlice';

const InvoiceLoadingState = ({ orderId, contificoStatus, onComplete }) => {
    const { data: invoiceStatus } = useGetInvoiceStatusQuery(orderId, {
        pollingInterval: 60000, // Poll every 60 seconds (1 minute) as per requirements
        skip: !orderId,
    });

    useEffect(() => {
        if (invoiceStatus?.status === 'AUTHORIZED' || invoiceStatus?.status === 'FAILED') {
            if (onComplete) {
                onComplete(invoiceStatus);
            }
        }
    }, [invoiceStatus, onComplete]);

    // Determine the message based on status
    const isPendingSRI = ['PENDING_SRI', 'RETRY_PENDING'].includes(contificoStatus);
    const isRetrying = contificoStatus === 'RETRY_PENDING';

    return (
        <Alert variant="info" className="p-4 text-center border-0 shadow-sm">
            <div className="d-flex flex-column align-items-center gap-3">
                <div className="d-flex align-items-center gap-2">
                    <Spinner animation="border" variant="primary" size="sm" />
                    <FaClock className="text-primary" size={20} />
                </div>
                <div>
                    <h6 className="fw-bold mb-2">
                        <FaCheckCircle className="me-2 text-success" />
                        ✓ Pago Exitoso - Factura siendo procesada
                    </h6>
                    <p className="mb-2 small">
                        {isPendingSRI ? (
                            <>
                                <strong>Tu factura está siendo procesada por el SRI</strong> (servicio de impuestos de Ecuador).
                                {isRetrying && ' El sistema está reintentando la autorización.'}
                            </>
                        ) : (
                            <>
                                <strong>Tu factura está siendo generada y autorizada.</strong>
                            </>
                        )}
                    </p>
                    <p className="mb-2 small text-muted">
                        Este proceso puede tomar <strong>hasta 24 horas</strong> debido a retrasos del SRI.
                        La página se actualiza automáticamente cada minuto.
                    </p>
                    <p className="mb-0 small text-muted fst-italic">
                        💡 No te preocupes: Tu pago fue exitoso. Recibirás tu factura en cuanto el SRI complete la autorización.
                    </p>
                </div>
            </div>
        </Alert>
    );
};

export default InvoiceLoadingState;

